export default __webpack_public_path__ + "images/e9f4e7d3e0a259ea00ad3a79326cd398-blues_and_jazz.webp";